import { useInstanceEffect } from '@/scenarios/legacy-player/hooks/useInstanceEffect';

export const useOnDurationChanged = (onDurationChanged: (duration: number) => void) => {
    useInstanceEffect(
        (instance) => instance.onDurationChange(onDurationChanged),
        [onDurationChanged]
    );
};
